/** 接收 */
export function receiveUni() {
    window.jsfunction = function (data) {

    };
}
/** 发送 */
async function postUni () {
    await isReady()
    console.log('向uni发送登出接口')
    uni.postMessage();
}

export const Logout = debounce(postUni,200,true)

function isReady() {
    return new Promise(resolve => {
        if(sessionStorage.getItem('UniAppJSBridgeReady')) {
            resolve(true)
        }
        document.addEventListener("UniAppJSBridgeReady", function () {
            sessionStorage.setItem('UniAppJSBridgeReady', true)
            resolve(true)
        });
    })
}

/**
 * 防反跳。fn函数在最后一次调用时刻的delay毫秒之后执行！
 * @param fn 执行函数
 * @param delay 时间间隔
 * @param isImmediate 为true，debounce会在delay时间间隔的开始时立即调用这个函数
 * @returns {Function}
 */
export function debounce(fn, delay, isImmediate) {
    var timer = null;  //初始化timer，作为计时清除依据
    return function() {
        var context = this;  //获取函数所在作用域this
        var args = arguments;  //取得传入参数
        clearTimeout(timer);
        timer = setTimeout(function() {
            fn.apply(context,args);
            timer = null;
        }, delay);
    }
}
